import style from "../assets/scss/common/header.module.scss";
import React from "react";
import {CookieKeys} from "../hooks/auth/AuthProvider";
import {useCookie} from "../hooks/auth/useCookie";

enum HostType {
    KPASS = "KPASS",
    DCAS = "DCAS"
}
export function HeaderLinkField() {
    const {getValueFromCookie} = useCookie();

    const accessToken = getValueFromCookie(CookieKeys.ACCESS_TOKEN);
    const refreshToken = getValueFromCookie(CookieKeys.REFRESH_TOKEN);

    const getDomainUrlByMode = (hostType: HostType) => {
        const isProd = process.env.REACT_APP_MODE === "운영";

        if (hostType === "KPASS") {
            return isProd ? "kpass.feel-good.io" : "kpass-dev.feel-good.io";
        } else {
            return isProd ? "dcas.feel-good.io" : "dcas-dev.feel-good.io";
        }
    }

    const handleRedirect = (host: HostType) => {
        const domain = getDomainUrlByMode(host)
        if (accessToken && refreshToken) {
            console.log("token available : ",domain)
            window.location.href = `https://${domain}/auth?accessToken=${encodeURIComponent(accessToken)}&refreshToken=${encodeURIComponent(refreshToken)}`;
        } else {
            window.location.href = `https://${domain}`;
            console.log("no token : ",domain)
        }
    };

    return(
        <div className={style.pageChanger}>
            <div className={style.btnWrapper} onClick={() => handleRedirect(HostType.KPASS)}>
                <div className={style.linkBtn}/>
                <span className={style.kpass}>K</span>-PASS
            </div>
            <div className={style.btnWrapper} onClick={() => handleRedirect(HostType.DCAS)}>
                <div className={style.linkBtn}/>
                <span className={style.dcas}>D</span>-CAS
            </div>
        </div>
    )
}